export enum EnumDashboardPeriodo {
    DIA = 0,
    MES = 1,
    ANO = 2,
    PERIODO = 3
}